export default {
  EMAIL_PASSWORD_FORM: 'EMAIL_PASSWORD_FORM',
  QR_CODE_OR_6DIGIT_FORM: 'QR_CODE_OR_6DIGIT_FORM',
  SETUP_6DIGIT_FORM: 'SETUP_6DIGIT_FORM',
  SUCCESS_FORM: 'SUCCESS_FORM',
  FORGOT_PASSWORD_FORM: 'FORGOT_PASSWORD_FORM',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
};
